export default {
      id: "progress-usage",
      viewBox: "0 0 26.349 26.35",
      url: "assets/" + "sprite.svg#progress-usage",
      toString: function () {
        return this.url;
      }
    }